module.exports = __webpack_public_path__ + "static/media/case-desktop.674442c9.svg";